import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import QuizRunner from '../Quizzes/QuizRunner';
import { api } from '../../utils/api';
import './CollegeAlgebra.css';

export default function Quiz() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [unit, setUnit] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api
      .get(`/api/college-algebra/units/${slug}`)
      .then((data) => setUnit(data.unit))
      .catch(() => setError('Unable to load this unit right now.'));
  }, [slug]);

  if (error) return <p className="ca-error">{error}</p>;
  if (!unit) return <p>Loading quiz&hellip;</p>;

  // QuizRunner/quizzes.js are already generic on topic.slug -- the College
  // Algebra unit's `id`/`slug` is stored in the same `topics` table as SAT
  // domains, so the practice-quiz engine (adaptive by skill, GET/POST
  // /api/quizzes/:topicSlug/...) works unchanged. exam_weight_pct only
  // exists so QuizRunner picks the standard 10-question count instead of
  // the SAT "mixed practice" 50-question count (exam_weight_pct === 0).
  const topic = { slug: unit.slug, name: unit.name, exam_weight_pct: 1 };

  return (
    <div className="ca-page">
      <QuizRunner topic={topic} onExit={() => navigate(`/college-algebra/units/${slug}`)} />
    </div>
  );
}
